module.exports = __webpack_public_path__ + "img/pocket-14_en.7ad4fbb.jpg";